<template>
    <b-container fluid class="top-padding bottom-padding no-horiz-padding">

        <h2>Weaving Draft Archive: ({{draftsCount}} drafts available)</h2>

        <b-button-group class='right-margin bottom-margin'>
            <b-dropdown variant='primary' left text="Search for Drafts">
                <b-dropdown-item to='/collection-drafts/collection'>Search by Collection</b-dropdown-item>
                <b-dropdown-item to='/collection-drafts/keyword'>Search by Keyword or ID</b-dropdown-item>
                <b-dropdown-item to='/tag-cloud/alltags'>Search by Tag</b-dropdown-item>
                <b-dropdown-item to='/board-search'>Search by Board</b-dropdown-item>
                <b-dropdown-item to='/draft-threading-search'>Search by Threading</b-dropdown-item>
                <b-dropdown-divider></b-dropdown-divider>
                <b-dropdown-item to='/collection-drafts/alllikes'>Most Liked Drafts</b-dropdown-item>
                <b-dropdown-item to='/collection-drafts/popular'>Popular Drafts (Most Viewed)</b-dropdown-item>
                <b-dropdown-item to='/collection-drafts/newest'>Newest Drafts</b-dropdown-item>
                <b-dropdown-item to='/collection-drafts/surprise'>Surprise: Random Drafts</b-dropdown-item>
            </b-dropdown>
        </b-button-group>

        <b-button variant='primary' class="right-margin bottom-margin" href="/draft-editor">Color Editor &raquo;</b-button>

        <b-button-group v-if='this.isAuthenticated' class='right-margin bottom-margin'>
            <b-dropdown variant='primary' left text="Your Drafts">
                <b-dropdown-item to='/tag-cloud/mytags'>Tagged</b-dropdown-item>
                <b-dropdown-item to='/myboards'>Boards</b-dropdown-item>
                <b-dropdown-item to='/collection-drafts/mylikes'>Liked</b-dropdown-item>
                <b-dropdown-item to='/draft-editor'>Color Editor</b-dropdown-item>
            </b-dropdown>
        </b-button-group>

        <b-button v-if='this.isAuthenticated' variant='primary' class="right-margin bottom-margin" href="/draft-contribute">Contribute Drafts &raquo;</b-button>

        <share-button/>

        <div class="vertical-padding">
            <h2>Draft&nbsp;Collections</h2>
        </div>

        <div class="grey-background-two">
            <div class='cover-image-container inline-auto-width' v-for="collection in collectionsList" :key='collection.BookID'>
                <router-link :to='collection.FirstPageUrl' :title="collection.TitleWithAuthors">
                    <img class='cover-image bottom-padding' :src='collection.CoverImageUrl' :alt="'Collection Cover Image Image for: ' + collection.TitleWithAuthors" />
                </router-link>
                <br />
                <router-link :to='collection.FirstPageUrl' :title="collection.TitleWithAuthors">
                    {{collection.TitleWithAuthors}}, ({{collection.PublicationDate}}), {{collection.TotalPatterns}} drafts
                </router-link>
            </div>
        </div>

        <div class="vertical-padding">
            <h2 style="padding-bottom:0">Featured Draft</h2>
            <router-link :to="featuredDraftDetailPageUrl" :title="featuredDraft.Tooltip">
                <h4>{{featuredDraft.DisplayTitle}}, Draft #{{featuredDraft.PatternID}}</h4>
            </router-link>
        </div>

        <div class="bottom-padding">
            <span class="small-bottom-padding" style="font-weight: bold">Warp</span>
            <span class="small-bottom-padding">Unit&nbsp;{{featuredDraft.WarpUnitThreads}} Reps:&nbsp;{{featuredDraft.WarpRepeatsShown}} Front Float:&nbsp;{{featuredDraft.MaxFrontWarpFloat}}, Back Float: &nbsp;{{featuredDraft.MaxBackWarpFloat}}</span>
            <br />
            <span class="small-bottom-padding" style="font-weight: bold">Weft</span>
            <span class="small-bottom-padding">Unit&nbsp;{{featuredDraft.WeftUnitThreads}} Reps:&nbsp;{{featuredDraft.WeftRepeatsShown}} Front Float:&nbsp;{{featuredDraft.MaxFrontWeftFloat}}, Back Float:&nbsp;{{featuredDraft.MaxBackWeftFloat}}</span>
            <br />
            <span class="small-bottom=paddint">Min&nbsp;Shafts:&nbsp;{{featuredDraft.Shafts}}, Min&nbsp;Treadles:&nbsp;{{featuredDraft.Treadles}}</span>
        </div>

        <div class="bottom-padding">
            <router-link :to="featuredDraftDetailPageUrl" :title="featuredDraft.Tooltip">
                <img :src='featuredDraftImageUrl' :alt='"draft image: " + featuredDraft.Tooltip' />
            </router-link>
        </div>

        <help-us-button/>
        <mail-chimp-signup/>
    </b-container>
</template>

<script>
import dataService from '../mixins/dataService.js'
import mediaService from '../mixins/mediaService.js'
import urlsService from '../mixins/urlsService.js'
import helpUsButton from './HelpUsButton.vue'
import mailChimpSignup from './MailChimpSignup.vue'
import shareButton from './ShareButton.vue'

export default {
    mixins: [dataService, mediaService, urlsService],
    data: function() {
        return {
            collectionsList: [],
            draftsCount: 0,
            featuredDraft: { Tooltip: '' },
            featuredDraftImageUrl: '',
            featuredDraftDetailPageUrl: '',
            orientation: 'tl',
            orientationInitialized: false
        }
    },
    methods: {
        initializeComponent() {
            this.getCollectionsList().then(resp => {
                this.collectionsList = resp.data
            })
            this.getPatternsCount().then(resp => {
                this.draftsCount = resp.data
            })
            let countToRetrieve = 1
            let maxWarpThreads = 75
            let maxWeftThreads = 75
            let minShafts = 1
            let maxShafts = 100
            let maxTreadles = 100
            let maxFloatLength = 100
            this.getRandomPatterns(countToRetrieve, minShafts, maxShafts, maxTreadles, maxFloatLength, maxWarpThreads, maxWeftThreads).then(resp => {
                this.featuredDraft = resp.data[0]
                let displaySize = this.calculateDraftInitialDisplaySize(this.featuredDraft, window.innerWidth, false)
                this.featuredDraftImageUrl = this.draftImageUrl(this.featuredDraft.PatternID, displaySize, this.currentOrientation, false, false, false, false, false, false, false, false, false, false, this.featuredDraft.ImagesExist, this.isSubscriber)
                this.featuredDraftDetailPageUrl = this.buildDraftDetailUrl(this.featuredDraft)
            })
        }
    },
    components: {
        helpUsButton: helpUsButton,
        mailChimpSignup: mailChimpSignup,
        shareButton: shareButton
    },
    computed: {
        isSubscriber: function() {
            return this.$store.getters.isSubscriber
        },
        isAuthenticated: function() {
            return this.$store.getters.isAuthenticated
        },
        currentOrientation: function() {
            if (this.$store.getters.isSubscriber) {
                if (!this.orientationInitialized) {
                    this.orientation = this.$store.state.authUserSettings.Orientation
                    this.orientationInitialized = true
                }
            }
            return this.orientation
        }
    },
    created() {
        this.initializeComponent()
        this.$store.commit('setPageTitle', 'Weaving Drafts Archive')
    }
}
</script>

<style scoped>
    .cover-image-container {
        vertical-align: top; 
        padding: 10px; 
        padding-bottom: 20px; 
        width: 280px
    }

    .cover-image {
        max-height: 226px;
        max-width: 260px;
        vertical-align: top
    }
</style>



// WEBPACK FOOTER //
// src/components/Drafts.vue